export const forms = {
	validation: {
		required: "{{field}} is required",
		min: "{{field}} must be at least {{min}} characters",
		max: "{field} must be at least {{max}} characters",
		invalid: "{{field}} is not valid",
		lowercase: "{{field}} must contain at least one lowercase letter",
		uppercase: "{{field}} must contain at least one uppercase letter",
		number: "{{field}} must contain at least one number",
		special_character: "{{field}} must contain at least one special character",
	},
	email: {
		label: "Email",
		placeholder: "you@example.com",
	},
	password: {
		label: "Password",
		placeholder: "Enter password",
		password_match: "Passwords must match",
	},
	first_name: {
		label: "First name",
		placeholder: "Jhon",
	},
	last_name: {
		label: "Last name",
		placeholder: "Doe",
	},
};
